module.exports = __webpack_public_path__ + "odinstatic/media/operator-info.45432e86.svg";